export const View = ({
  text,
  className = "",
  buttonClassName = "",
  contentClassName = "",
  renderButton,
  children,
}) => {
  return (
    <div className={`hover-dropdown ${className}`}>
      {renderButton}
      {renderButton ? (
        <></>
      ) : (
        <button className={`hover-dropdown--button ${buttonClassName}`}>
          {text}
        </button>
      )}

      <div className={`hover-dropdown--content ${contentClassName}`}>
        {children}
      </div>
    </div>
  );
};
